import { request as apiRequest } from '@/lib/apiClient'

async function apiFetch<T>(method: string, path: string, body?: unknown): Promise<T> {
  const { data, error } = await apiRequest<T>(method, path, body)
  // error.message carries the server's message verbatim — including the Phase-1
  // guardrail refusals ("Cannot demote the last super admin.", etc.), which the
  // page surfaces to the user.
  if (error) throw new Error(error.message)
  return data as T
}

export type AppRoleValue = 'execution' | 'design' | 'strategy' | 'super_admin'

// one row per auth.users account, joined to its effective role.
export interface UserRoleRow {
  user_id:     string
  email:       string
  created_at:  string
  role:        AppRoleValue
  role_id:     string | null   // null → no app_roles row (effective 'user')
  created_by:  string | null
  updated_at:  string | null
}

export const rolesApi = {
  // every account with its effective role (requireInternal on the backend)
  listUsers(): Promise<UserRoleRow[]> {
    return apiFetch<UserRoleRow[]>('GET', '/api/app-roles/users')
  },

  grant(email: string, role: Exclude<AppRoleValue, 'execution'>): Promise<unknown> {
    return apiFetch('POST', '/api/app-roles', { email, role })
  },

  change(roleId: string, role: Exclude<AppRoleValue, 'execution'>): Promise<unknown> {
    return apiFetch('PUT', `/api/app-roles/${roleId}`, { role })
  },

  // 'admin'/'super_admin' → 'user' : deletes the row (absent = user)
  revoke(roleId: string): Promise<unknown> {
    return apiFetch('DELETE', `/api/app-roles/${roleId}`)
  },

  deleteAccount(userId: string): Promise<unknown> {
    return apiFetch('DELETE', `/api/app-roles/users/${userId}`)
  },
}
